import React from "react";
import { render } from "react-dom";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import thunk from "redux-thunk";
import b2cauth from "react-azure-adb2c";
import decodeJWT from "jwt-decode";
import "react-dropdown-tree-select/dist/styles.css";

import "./build/css/emojionearea.css";
import "./build/css/main.min.css";
import "./components/PlatformNps/platformnps.css";

import rootReducer from "./reducers";
import App from "./components/App";
import Senha from "./components/Senha";
import Login from "./components/Login";
import ChangePassword from "./components/ChangePassword";
import Dashboard from "./components/Dashboard";
import Historic from "./components/HistoryCalls";
import Native from "./components/Native";
import Azure from "./components/Azure";
import IntegrationIngDesk from "./containers/IntegrationIngDesk";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import LoginV2 from "./components/LoginV2";

library.add(fas, far, fab);

const store = createStore(rootReducer, applyMiddleware(thunk));
const { connection_platform } = require("./services/api");

var idtoken = localStorage.getItem("msal.idtoken");
var decoded = [];

if (idtoken) {
  decoded = decodeJWT(idtoken);
}
//   window.open(`${'http'}://${window.location.hostname}:${connection_platform.port_node}/azure`, "_self");
// }

// b2cauth.initialize({
//   instance: 'https://login.microsoftonline.com/6ea2fa19-75a2-4a40-9e64-e58875df8567',
//   tenant: '',
//   signInPolicy: '',
//   applicationId: '5622cf86-4185-40e3-934d-a9a5f5a5e614',
//   cacheLocation: 'localStorage',
//   scopes: [''],
//   redirectUri: 'http://localhost:3006',
//   postLogoutRedirectUri: window.location.origin,
//   validateAuthority: false,
//   oauth2AllowImplicitFlow: true
// });

//SOTREQ
// b2cauth.initialize({
//   instance:
//     "https://login.microsoftonline.com/c9cd0976-a8f6-490a-b5f8-7a765745cb75",
//   tenant: "",
//   signInPolicy: "",
//   applicationId: "34ea94cb-8ea4-476f-a732-0cf140a94861",
//   cacheLocation: "localStorage",
//   scopes: [""],
//   redirectUri: "https://sotreq-ims.jcr.net.br",
//   postLogoutRedirectUri: window.location.origin,
//   validateAuthority: false,
//   oauth2AllowImplicitFlow: true,
// });

//AVIVA
// b2cauth.initialize({
//   instance:
//     "https://login.microsoftonline.com/e01cae07-6251-49c7-8c5e-d6f07cffecc7",
//   tenant: "",
//   signInPolicy: "",
//   applicationId: "975b292c-c151-4ee3-900b-7d2588168d9d",
//   cacheLocation: "localStorage",
//   scopes: [""],
//   redirectUri: "https://aviva.ingweb.com.br",
//   postLogoutRedirectUri: window.location.origin,
//   validateAuthority: false,
//   oauth2AllowImplicitFlow: true,
// });

console.log("INGENIUM_APIINDEX : ",connection_platform.azureconfiguration)
b2cauth.initialize(connection_platform.azureconfiguration);


if (connection_platform.azure_auth === true) {
  b2cauth.run(() => {
    ReactDOM.render(
      <Provider store={store}>
        <IntegrationIngDesk />
        <BrowserRouter>
          <Switch>
            <Route path="/" component={Azure} />
            <Route path="/login" component={LoginV2} />
            <Route path="/senha" component={Senha} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/historic" component={Historic} />
            <Route path="/changepassword" component={ChangePassword} />
            <Route path="/native" component={Native} />
            <Route path="/logout" component={LoginV2} />
            <Route path="/azure" component={Azure} />
          </Switch>
        </BrowserRouter>
      </Provider>,
      document.getElementById("app")
    );
  });
} else {
  render(
    <Provider store={store}>
      <IntegrationIngDesk />
      <BrowserRouter>
        <Switch>
          <Route path="/" exact={true} component={LoginV2}/>
          <Route path="/login" component={LoginV2}/>
          <Route path="/senha" component={Senha} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/historic" component={Historic} />
          <Route path="/changepassword" component={ChangePassword} />
          <Route path="/native" component={Native} />
          <Route path="/logout" component={LoginV2} />
          <Route path="/azure" component={Azure} />
        </Switch>
      </BrowserRouter>
    </Provider>,
    document.getElementById("app")
  );
}
